/**
 * Teaser.
 */

const Teaser = ( { teaser } ) => {
	return (
		<div className="teaser teaser--compact teaser-s">
			{ teaser.thumbnail && 'undefined' !== typeof teaser.thumbnail &&
				<figure className="teaser__image">
					<img src={ teaser.thumbnail.src } alt="" width={ teaser.thumbnail.width } height={ teaser.thumbnail.height } loading="lazy" />
				</figure>
			}
			<div className="teaser__content">
				<div className="teaser__header">
					{ teaser.boventitel && 'undefined' !== typeof teaser.boventitel &&
						<div className="teaser__label">
							<span className="teaser__label-text">{ teaser.boventitel }</span>
						</div>
					}
					{ teaser.post_title && 'undefined' !== typeof teaser.post_title &&
						<h4 className="teaser__title">
							<a href={ teaser.permalink } className="teaser__link" data-gtm-id="facetfilter_searchclick">
								<span className="teaser__highlight" dangerouslySetInnerHTML={{ __html: teaser.post_title }}></span>
							</a>
						</h4>
					}
				</div>
			</div>
			<div className="teaser__details">
				{ teaser.location && 'undefined' !== typeof teaser.location && (
					<div className="teaser__detail teaser__detail--location">
						<span className="icon icon--pin icon-size--m icon-space--after"></span>{ 'multiple' === teaser.location ? 'Meerdere locaties' : teaser.location }
					</div>
				) }
				{ teaser.date && 'undefined' !== typeof teaser.date && (
					<div className="teaser__detail teaser__detail--date">
						<span className="icon icon--calendar icon-size--m icon-space--after"></span>{ teaser.date }
					</div>
				) }
			</div>
		</div>
	)
}

export default Teaser;
